/**
 * One attempt of this application, not one action.
 *
 * The api makes an attempt idempotent by this identifier: a retry of the same attempt does
 * nothing the second time. So a genuinely new action - a new answer after editing the text, a
 * second grant to the same client - has to mint a new one, and that is why it is generated per
 * attempt and never held for the life of a screen.
 *
 * Only the browser knows that two requests are one intention. An identifier minted on the
 * server would be fresh on every request and would deduplicate nothing.
 */
export function newRequestId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  // jsdom and old webviews. Shaped like a uuid rather than merely unique: the grant route
  // parses it as one and refuses anything else, so "unique enough" would be a 400 there
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (placeholder) => {
    const digit = Math.floor(Math.random() * 16);
    return (placeholder === "x" ? digit : (digit & 0x3) | 0x8).toString(16);
  });
}
